import React from 'react'

import createGame from '../../actions/createGame'
import {
  Page,
  H1,
  Input,
  Button,
} from '../styles'

class New extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      inputValue: '',
    }
  }

  _handleInput = (event) => {
    this.setState({
      inputValue: event.target.value,
    })
  }

  _handleSubmit = (event) => {
    createGame(this.state.inputValue).then(id => {
      this.props.history.push(`/game/${id}`)
    })
  }

  render() {
    return <Page>
      <H1>Name your game</H1>
      <p>{`Choose a name that describes the group you're playing with (like 'home friends' or 'ski trip')`}</p>
      <Input autoFocus value={this.state.inputValue} onChange={this._handleInput} />
      <Button primary onClick={this._handleSubmit} disabled={this.state.inputValue.length < 1}>Invite players</Button>
    </Page>
  }

}

export default New



// WEBPACK FOOTER //
// ./src/views/lobby/New.jsx